const budgetRange = [
  { label: "10,000 - 20,000 $", value: "10000-20000" },
  { label: "20,000 - 30,000 $", value: "20000-30000" },
  { label: "30,000 - 40,000 $", value: "30000-40000" },
  { label: "40,000 - 50,000 $", value: "40000-50000" },
  { label: "> 50,000 $", value: "50000-100000000" },
];

const budgetValues = [
  { title: "All", value: "" },
  { title: "0 - 20,000 $", value: "0-20000" },
  { title: "20,000 - 40,000 $", value: "20000-40000" },
  { title: "40,000 - 60,000 $", value: "40000-60000" },
  { title: "60,000 - 80,000 $", value: "60000-80000" },
  { title: "> 80,000 $", value: "80000-100000000" },
];

export { budgetRange, budgetValues };
